module.exports = __webpack_public_path__ + "img/preset-delivery.7c125f1d.svg";